import { type FC } from 'react';
import { Box, Link } from '@mui/material';
import { FileText } from 'lucide';
import Icon from 'common/components/Icon';
import { pdfFileParser } from '../utils';

interface PdfListProps {
  pdfPaths: string[];
  onPdfClick: (pdfUrl: string, fileName: string) => void;
}

const PdfList: FC<PdfListProps> = ({ pdfPaths, onPdfClick }) => {
  return (
    <>
      {pdfPaths.map((pdfPath, index) => {
        const pdf = pdfFileParser(pdfPath);
        const name = pdf.fileName || `PDF ${index + 1}`;

        return (
          <Box key={index} sx={{ marginBottom: 1 }}>
            <Link
              component="button"
              type="button"
              underline="hover"
              onClick={() => onPdfClick(pdf.to, name)}
              sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, textAlign: 'left' }}
            >
              <Icon icon={FileText} size={16} />
              {name}
            </Link>
          </Box>
        );
      })}
    </>
  );
};

export default PdfList;
